import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { NUMBER_ARRAY } from 'common/global/constants';
import { RedTheme } from 'common/global';
import { useScreen } from 'common/hooks/useScreen';
import { Stack } from '@mui/system';

const buttonStyle = {
    height: '40px',
    width: '140px',
    borderRadius: '12px',
    textTransform: 'none',
    fontFamily: '"JohnsonText-Regular"',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: NUMBER_ARRAY.fiveHundred
};


export const GenericPopUpUserProfile = ({
    open = false, 
    onClose = () => {}, 
    onConfirm = () => {}, 
    title = "", 
    titleSubHeader = '',
    rightButtonText = "",
    leftButtonText = "",
    disableSaveButton = false,
    children, 
    cssOverFlowProp = 'auto'
}) => {
    const redTheme = RedTheme;
    const screen = useScreen();
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: screen.resolveStyles({
            mobile: '360px',
            tablet: '745px',
            desktop: '918px',
        }),
        bgcolor: 'background.paper',
        boxShadow: NUMBER_ARRAY.twentyFour,
        p: NUMBER_ARRAY.four,
        borderRadius: NUMBER_ARRAY.two,
        maxHeight: screen.isMobile ? '510px' : '578px',
        overflow: cssOverFlowProp
    };

    return (
        <Modal open={open}>
            <Box sx={style}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Stack direction={'column'} sx={{marginBottom: '12px'}}>
                        <Typography variant="h6" component="h2" fontFamily={'"JohnsonDisplay-Bold"'}>
                            {title}
                        </Typography>
                        <Typography sx={{ color: redTheme.palette.text.gray }}>
                            {titleSubHeader}
                        </Typography>
                    </Stack>
                    <IconButton aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box>
                    {children}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: NUMBER_ARRAY.three}}>
                    <Button onClick={onClose} variant="outlined" sx={{ ...buttonStyle, mr:  NUMBER_ARRAY.two, color: redTheme.palette.text.primary, border: `1px solid ${redTheme.palette.text.primary}`}}>
                        {leftButtonText}
                    </Button>
                    <Button onClick={onConfirm} variant="contained" disabled={disableSaveButton} sx={{ ...buttonStyle}}>
                        {rightButtonText}
                    </Button>
                </Box>

            </Box>

        </Modal>
    )
}